export default "__VITE_ASSET__DqG3flFd__"